import { takeEvery, fork, put, all, call } from "redux-saga/effects"

//Account Candidate Management
import { CANDIDATE_COUNT,CANDIDATE_SEARCH_COUNT } from "./actionTypes"
import { candidateCountSuccessful, candidateCountFailed ,candidateSearchCountSuccessful,candidateSearchCountFailed} from "./actions"

import {
  candidateCount,candidateSearchCount
} from "../../../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../../../common/constant/constantURL"

// get candidate list
function* getCandidateCount({ payload: { user } }) {
  try 
  {
    var url=constClass.REST_API_GET_CANDIDATE_COUNT;
    
    //calling candidates count api
    var responsJSON = yield call(candidateCount, url);
    yield put(candidateCountSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(candidateCountFailed(error))
  }
}
// get search candidate list
function* getSearchListCount({payload :{user}}) {
  try 
  {

    var url=constClass.REST_API_SEARCH_CANDIDATE_COUNT;
    
    //calling candidates count api
    var responsJSON = yield call(candidateSearchCount, url,user);
    yield put(candidateSearchCountSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(candidateSearchCountFailed(error))
  }
}
export function* watchCandidateCount() {
  yield takeEvery(CANDIDATE_COUNT, getCandidateCount)
  yield takeEvery(CANDIDATE_SEARCH_COUNT, getSearchListCount);
}

function* candidateCountSaga() {
  yield all([fork(watchCandidateCount)])
}

export default candidateCountSaga